import { gql, useMutation } from "@apollo/client";
import React, { useContext, useState } from "react";
import {
  BreadCrumb,
  BreadCrumbProp,
} from "../../../components/light/Breadcrumb";
import { Content } from "../../../components/light/Content";
import { SectionBlock } from "../../../components/light/SectionBlock";
import { ContextUser } from "../../../context/ContextUser";
import { Toast } from "../../../hooks/toast";
import { FieldLoginLess } from "./FieldLoginLess";

const BreadCrumbItems: BreadCrumbProp[] = [
  { text: "applications", to: "#" },
  { text: "orders", to: "#" },
  { text: "orders loginless", to: "/orders/loginless" },
];

const LOGINLESS = gql`
mutation createLoginlessOrder($phoneNumber: String!, $items: [LoginlessOrderItemInput], $referral: String){
  createLoginlessOrder(phoneNumber: $phoneNumber, items: $items, referral: $referral)
}
`

export function LoginLessScreen() {
  const context = useContext(ContextUser);
  const [phone, setPhone] = useState("");
  const [items, setItems] = useState<any[]>([{}]);
  const [createLoginlessOrder] = useMutation(LOGINLESS, {
    onCompleted: res => {
      if(res.createLoginlessOrder) {
        Toast.onShow('Create Loginless Order #'+res.createLoginlessOrder, 'success', 'right');
        setPhone('');
        setItems([{}]);
      }
    }
  });

  const handleSave = () => {
    const sku: {skuId: number}[] = [];

    for(let i = 0; i<items.length; i++) {
      const size: any = document.getElementById('size'+i);
      const unit: any = document.getElementById('unit'+i);

      if(Number(unit.value) >= 1) {
        for(let u = 0; u < Number(unit.value); u++){
          sku.push({skuId: Number(size.value)});
        }
      }
    }

    if(!phone || sku.length === 0) {
      Toast.onShow('Information input is not completed', 'danger', 'right');
      return;
    }

    const data = {
      phoneNumber: phone,
      referral: context.merchant.id,
      items: sku
    }

    createLoginlessOrder({
      variables: data
    })
  }

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-7">
          <SectionBlock title="Loginless Order">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Customer Phonenumber</label>
                  <input
                    type="text"
                    className="form-control form-control-sm form-secondary"
                    placeholder="Enter phone"
                    value={phone}
                    onChange={e => setPhone(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-6 text-right">
                <button className="btn btn-primary btn-sm" onClick={handleSave}>Save</button>
              </div>
              <div className="col-md-12">
                <table className="table table-striped table-lightfont dataTable">
                  <thead>
                    <tr>
                      <th>Product Code</th>
                      <th>Color</th>
                      <th>Size</th>
                      <th>Current Stock</th>
                      <th>Unit</th>
                      <th>Remote Duration</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((x, i) => {
                      return (
                        <FieldLoginLess
                          id={i+""}
                          isAdd={i === items.length - 1}
                          onAdd={() => setItems([...items, {}])}
                          onRemove={() => {
                            setItems(
                              items.filter((item, index) => index !== i)
                            );
                          }}
                        />
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </SectionBlock>
        </div>
      </div>
    </Content>
  );
}
